module.exports = __webpack_public_path__ + "static/img/11.06756b7e.jpeg";